import PropTypes from 'prop-types'
import React from 'react'

import { ScrollArea } from 'react-wot-bootstrap'

import ArenaTooltip from 'components/ArenaTooltip/ArenaTooltip.jsx'
import { toRoman } from 'helpers'
import { FortBattleSeries, RoundResultTooltip } from '../../components'

import { POSTBATTLE_ROW_HEIGHT, POSTBATTLE_MAX_ROWS } from '../../constants.jsx'
import {
    POST_BATTLE_BATTLE_LIST_OUTCOMES,
} from './constants.jsx'

import { FORT_BATTLE_SERIES_RESULT } from 'constants'
import { POST_BATTLE_TABLE_HEADER } from 'helpers/i18n.jsx'

import classNames from 'classnames'
import styles from './BattleList.scss'


export class BattleList extends React.Component {

    static propTypes = {
        battles: PropTypes.arrayOf(PropTypes.object).isRequired,
        ownClanId: PropTypes.number.isRequired,
        enemyClanId: PropTypes.number.isRequired,
    }

    render() {

        const columnClassName = (type, name) => (
            classNames(styles[`${type}`], styles[`${type}__${name}`])
        )
        const rows = this.props.battles.map((battle, index) => {

            const outcome = battle.is_win ? FORT_BATTLE_SERIES_RESULT.VICTORY :
                (battle.is_draw ? FORT_BATTLE_SERIES_RESULT.DRAW : FORT_BATTLE_SERIES_RESULT.DEFEAT)

            const rowClassName = classNames(styles.tr, styles[`tr__${outcome}`])
            const resultOutcomeClassName = classNames(styles.result, styles.result__outcome)

            const arenaTooltipId = `battle_series_arena_${battle.arena.id}_${index}`
            const resultTooltipId = `round_result_${index}`

            const roundResult = {
                ...battle,
                fort_battle_state: this.props.battles[index - 1] && this.props.battles[index - 1].fort_battle_state,
            }

            return (
                <div key={`battle_${index}`} className={rowClassName}>
                    <div className={columnClassName('td', 'results')} data-tip data-for={resultTooltipId}>
                        <span className={resultOutcomeClassName}>
                            {POST_BATTLE_BATTLE_LIST_OUTCOMES[outcome]}
                        </span>
                    </div>
                    <div className={columnClassName('td', 'points')} data-tip data-for={resultTooltipId}>
                        <FortBattleSeries
                            fortBattleSeries={battle.fort_battle_state}
                            ownClanId={this.props.ownClanId}
                            enemyClanId={this.props.enemyClanId}
                            isEngagement={index === 0}
                        />
                    </div>
                    <div className={columnClassName('td', 'maps')}>
                        <span data-tip data-for={arenaTooltipId}>
                            {`${battle.arena.name} (${toRoman(battle.respawn)})`}
                        </span>
                    </div>
                    <ArenaTooltip arena={battle.arena} tooltipId={arenaTooltipId} />
                    <RoundResultTooltip
                        tooltipId={resultTooltipId}
                        roundResult={roundResult}
                    />
                </div>
            )
        })

        const header = (
            <div className={styles.tr}>
                <div className={columnClassName('th', 'results')}>
                    {POST_BATTLE_TABLE_HEADER.results}
                </div>
                <div className={columnClassName('th', 'points')}>
                    {POST_BATTLE_TABLE_HEADER.points}
                </div>
                <div className={columnClassName('th', 'maps')}>
                    {POST_BATTLE_TABLE_HEADER.maps}
                </div>
            </div>
        )

        return (
            <div className={styles.base}>
                <div className={styles.table}>
                    <div className={styles.thead}>
                        {header}
                    </div>
                    <div className={styles.tbody}>
                        <ScrollArea
                            stepHeight={POSTBATTLE_ROW_HEIGHT}
                            scrollableAreaHeight={POSTBATTLE_ROW_HEIGHT * POSTBATTLE_MAX_ROWS}
                            modifier='postbattleDetails'
                        >
                            {rows}
                        </ScrollArea>
                    </div>
                </div>
            </div>
        )
    }
}

export default BattleList



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/BattleList/BattleList.jsx